import type { LucideIcon } from 'lucide-react'

interface EmptyStateProps {
  icon: LucideIcon
  title: string
  description: string
  action?: {
    label: string
    onClick: () => void
  }
}

export function EmptyState({ icon: Icon, title, description, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-center">
      <div className="w-16 h-16 rounded-2xl bg-white border border-[#E2E4ED] flex items-center justify-center mb-4">
        <Icon className="w-7 h-7 text-[#555A73]" strokeWidth={1.25} />
      </div>
      <p className="text-[#1B2559] font-semibold mb-1">{title}</p>
      <p className="text-[#8B8FA7] text-sm mb-6 max-w-sm">{description}</p>
      {action && (
        <button
          onClick={action.onClick}
          className="flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-orion-primary to-[#7C3AED] text-white text-sm font-medium rounded-xl hover:opacity-90 transition-opacity"
        >
          {action.label}
        </button>
      )}
    </div>
  )
}
